module.exports = __webpack_public_path__ + "img/totegamma.513dedcc.jpg";